/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { ITopAnnouncementBetModel } from '../../entities/Models/TopAnnouncementBetModel';

export type TGetTopBetsByAnnouncementModel = IModel<
  IGetTopBetsByAnnouncementRequest,
  TGetTopBetsByAnnouncementResponse
>;

export interface IGetTopBetsByAnnouncementRequest {
  /** Количество позиций **/
  topCount?: number | null;
  /** Id объявления **/
  announcementId?: number | null;
  /** Категория объявления **/
  category?: ECategory | null;
  /** Id локации **/
  geoId?: number | null;
  /** Тип локации **/
  geoType?: EGeoType | null;
  /** Уровень конкуренции **/
  concurrencyType?: EConcurrencyType | null;
  /** Цена **/
  price?: number | null;
  /** Услуга **/
  service?: EService | null;
}

export type TGetTopBetsByAnnouncementResponse =
  | IGetTopBetsByAnnouncementResponse200
  | IGetTopBetsByAnnouncementResponse400;

export interface IGetTopBetsByAnnouncementResponse200 extends IModelResponse<IGetTopBetsByAnnouncementResponse> {
  statusCode: 200;
}

export interface IGetTopBetsByAnnouncementResponse400 extends IModelResponse<IGetTopBetsByAnnouncementResponseError> {
  statusCode: 400;
}

export interface IGetTopBetsByAnnouncementResponse {
  /** Модель текущей ставки данного объявления **/
  currentAnnouncementBet?: ITopAnnouncementBetModel | null;
  /** Список топа ставок среди прочих объявлений **/
  topAnnouncementsBets: ITopAnnouncementBetModel[];
  /** Категория объявления текстом **/
  announcementCategory: string;
  /** Время актуализации данных **/
  actualDataDate: string;
  /** Ссылка на выдачу **/
  serpUrl: string;
  /** Текст ссылки на выдачу **/
  serpUrlTitle: string;
}

export interface IGetTopBetsByAnnouncementResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetTopBetsByAnnouncementResponse | IGetTopBetsByAnnouncementResponseError;

export enum ECategory {
  /** Койко-место = 0 **/
  BedRent = 'bedRent',
  /** Здание = 1 **/
  BuildingRent = 'buildingRent',
  /** Здание = 2 **/
  BuildingSale = 'buildingSale',
  /** Готовый бизнес = 3 **/
  BusinessRent = 'businessRent',
  /** Готовый бизнес = 4 **/
  BusinessSale = 'businessSale',
  /** Аренда автосервис = 5 **/
  CarServiceRent = 'carServiceRent',
  /** Продажа автосервиса = 6 **/
  CarServiceSale = 'carServiceSale',
  /** Коммерческая земля = 7 **/
  CommercialLandRent = 'commercialLandRent',
  /** Коммерческая земля = 8 **/
  CommercialLandSale = 'commercialLandSale',
  /** Коттедж = 9 **/
  CottageRent = 'cottageRent',
  /** Коттедж = 10 **/
  CottageSale = 'cottageSale',
  /** Посуточная аренда койко-места = 11 **/
  DailyBedRent = 'dailyBedRent',
  /** Посуточная аренда квартиры = 12 **/
  DailyFlatRent = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа = 13 **/
  DailyHouseRent = 'dailyHouseRent',
  /** Посуточная аренда комнаты = 14 **/
  DailyRoomRent = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги = 15 **/
  DomesticServicesRent = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги = 16 **/
  DomesticServicesSale = 'domesticServicesSale',
  /** Квартира = 17 **/
  FlatRent = 'flatRent',
  /** Квартира = 18 **/
  FlatSale = 'flatSale',
  /** Доля в квартире = 19 **/
  FlatShareSale = 'flatShareSale',
  /** Помещение свободного назначения = 20 **/
  FreeAppointmentObjectRent = 'freeAppointmentObjectRent',
  /** Помещение свободного назначения = 21 **/
  FreeAppointmentObjectSale = 'freeAppointmentObjectSale',
  /** Гараж = 22 **/
  GarageRent = 'garageRent',
  /** Гараж = 23 **/
  GarageSale = 'garageSale',
  /** Дом/дача = 24 **/
  HouseRent = 'houseRent',
  /** Дом/дача = 25 **/
  HouseSale = 'houseSale',
  /** Часть дома = 26 **/
  HouseShareRent = 'houseShareRent',
  /** Часть дома = 27 **/
  HouseShareSale = 'houseShareSale',
  /** Производство = 28 **/
  IndustryRent = 'industryRent',
  /** Производство = 29 **/
  IndustrySale = 'industrySale',
  /** Участок = 30 **/
  LandSale = 'landSale',
  /** Квартира в новостройке = 31 **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Офис = 32 **/
  OfficeRent = 'officeRent',
  /** Офис = 33 **/
  OfficeSale = 'officeSale',
  /** Аренда общепита = 34 **/
  PublicCateringRent = 'publicCateringRent',
  /** Продажа общепита = 35 **/
  PublicCateringSale = 'publicCateringSale',
  /** Комната = 36 **/
  RoomRent = 'roomRent',
  /** Комната = 37 **/
  RoomSale = 'roomSale',
  /** Торговая площадь = 38 **/
  ShoppingAreaRent = 'shoppingAreaRent',
  /** Торговая площадь = 39 **/
  ShoppingAreaSale = 'shoppingAreaSale',
  /** Таунхаус = 40 **/
  TownhouseRent = 'townhouseRent',
  /** Таунхаус = 41 **/
  TownhouseSale = 'townhouseSale',
  /** Склад = 42 **/
  WarehouseRent = 'warehouseRent',
  /** Склад = 43 **/
  WarehouseSale = 'warehouseSale',
}

export enum EGeoType {
  /** Страна **/
  Country = 'country',
  /** Локация **/
  Location = 'location',
  /** Улица **/
  Street = 'street',
  /** Шоссе **/
  Road = 'road',
  /** Район **/
  District = 'district',
  /** Метро **/
  Underground = 'underground',
  /** Дом **/
  House = 'house',
}

export enum EConcurrencyType {
  /** Конкуренция в регионе **/
  Region = 'region',
  /** Локальная конкуренция **/
  Local = 'local',
  /** Конкуренция по соседству **/
  NearBy = 'nearBy',
}

export enum EService {
  /** Бесплатное **/
  Free = 'free',
  /** <a href="http://www.cian.ru/promo/adv/#color" target="_blank">Выделение цветом</a> **/
  Highlight = 'highlight',
  /** Платное **/
  Paid = 'paid',
  /** <a href="http://www.cian.ru/promo/adv/#premium" target="_blank">Премиум-объявление</a> **/
  Premium = 'premium',
  /** <a href="http://www.cian.ru/promo/adv/#top3" target="_blank">Топ 3</a> **/
  Top3 = 'top3',
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  Calltracking = 'calltracking',
  /** Аукцион **/
  Auction = 'auction',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetTopBetsByAnnouncementResponse): TResponse200;
  400(response: IGetTopBetsByAnnouncementResponseError): TResponse400;
}
